type AlertColor = 'failure' | 'warning' | 'info' | 'success';

export type ApplicationStatusAlertConfig = {
  title: string;
  reason: string;
  color: AlertColor;
};

type Epoch = { stepCode?: string | null; id?: number; name?: string | null } | null;

const REJECTED_REASON = 'Контрагент попал в список запрещенных организаций.';
const CHANGES_REQUIRED_REASON = 'Измените предмет сделки.';

const STEP_ALERTS: Array<{
  stepCode: string;
  config: ApplicationStatusAlertConfig;
}> = [
  {
    stepCode: 'TRANSFER-REJECTED',
    config: {
      title: 'Заявка отклонена',
      reason: REJECTED_REASON,
      color: 'failure',
    },
  },
  {
    stepCode: 'TRANSFER-2',
    config: {
      title: 'Требуются изменения',
      reason: CHANGES_REQUIRED_REASON,
      color: 'warning',
    },
  },
];

export function getApplicationStatusAlert(
  epoch: Epoch
): ApplicationStatusAlertConfig | null {
  const stepCode = epoch?.stepCode;
  if (!stepCode) return null;
  const entry = STEP_ALERTS.find((a) => a.stepCode === stepCode);
  return entry?.config ?? null;
}
